<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For Peter Ahlstrom</p>
<p class="ded0">Who is not only a good friend and great man,</p>
<p class="ded0">But one who has been reading my books since the days when they were terrible,</p>
<p class="ded0">And who strives very hard to keep them from being that way again.</p>
<p class="ded0">Insoluble, Incalculable, Indefinable. </p>
<p class="ded0">Indispensable.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?480977d0